import { Identifiable } from './identifiable';

export class BaseModel implements Identifiable {
  id: string;
  name?: string;

  constructor(id?: string, name?: string) {
    this.id = id;
    this.name = name;
  }
}
